export default __webpack_public_path__ + "static/media/LAIN21.XA[31].8c34b91f.mp4";